const aboutme = {
    "title": "About me!",
    "body": [
        "Go Programmer",
        "Faster, Faster, Faster.",
    ]
}

export default aboutme